import React, { lazy } from "react";
import { VIEW_PANEL_UPGRADE_PACKAGES } from "constants/permissions";

const PackagesPage = lazy(() => import("./PackagesPage"));

const packagesRoute = {
  path: "packages",
  element: <PackagesPage />,
  root: true,
  permission: VIEW_PANEL_UPGRADE_PACKAGES,
};

export default packagesRoute;
